import { useEffect, useState } from "react";
import { FiChevronRight, FiX } from "react-icons/fi";
import { NavLink } from "react-router-dom";
const AnnouncementBar = ({
  message = "New update",
  detail = "New welcome bonus LIVE on",
  linkLabel = "Casino Friday",
  linkHref = "/news",
  storageKey = "announcement:dismissed:v1",
}) => {
  const [open, setOpen] = useState(true);
  useEffect(() => {
    try {
      const dismissed = localStorage.getItem(storageKey);
      if (dismissed === "1") setOpen(false);
    } catch {}
    setTimeout(() => window.dispatchEvent(new Event("resize")), 0);
  }, [storageKey]);

  const close = () => {
    setOpen(false);
    try {
      localStorage.setItem(storageKey, "1");
    } catch {}
    setTimeout(() => window.dispatchEvent(new Event("resize")), 0);
  };

  if (!open) return null;

  return (
    <div className="w-full bg-black text-white dark:bg-[#1a1a1a] dark:text-gray-100 transition-colors duration-300">
      <div className="mx-auto max-w-[1120px] px-6">
        <div className="relative flex h-10 items-center justify-center text-xs sm:text-[13px]">
          <div className="flex items-center gap-1 whitespace-nowrap">
            <span className="opacity-80">{detail}</span>
            <NavLink
              rel="noreferrer"
              target="_blank"
              to={linkHref}
              className="ml-1 underline underline-offset-2 hover:opacity-90 dark:hover:text-gray-300 transition-colors"
            >
              {linkLabel}
            </NavLink>
            <FiChevronRight className="ml-1" />
          </div>
          <button
            aria-label="Dismiss announcement"
            onClick={close}
            className="absolute right-0 inline-flex h-7 w-7 items-center justify-center rounded-full hover:bg-white/10 dark:hover:bg-gray-700 transition-colors duration-200"
          >
            <FiX className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementBar;
